export default __webpack_public_path__ + "static/media/ashes-bkg.22315309.jpg";